import { Component } from "react";
import PropTypes from "prop-types";
import CheckBox from "../../../shared/CheckBox";
import ProfileIcon from "../../../shared/ProfileIcon";
import dayjs from "@shared/dayjs";
import * as TaskHelpers from "../TaskIndexModalHelpers";
import TaskSettings from "../TaskSettings";
import capitalize from "capitalize";
import Tooltip from "@shared/v2/Tooltip";
import { connect } from "react-redux";

class Task extends Component {
  constructor(props) {
    super(props);
    this.state = {
      task: props.task,
      user: props.user,
      multiSelectWatcher: props.multiSelectWatcher,
    };
    this.multiSelectWatcher = this.props.multiSelectWatcher.bind(this);
    this.showModal = TaskHelpers.showModal.bind(this);
    this.closeModal = TaskHelpers.closeModal.bind(this);
    this.handleTaskChange = TaskHelpers.handleTaskChange.bind(this);
    this.handleMultiSelect = TaskHelpers.handleMultiSelect.bind(this);
    this.showModalComplete = TaskHelpers.showModalComplete.bind(this);
    this.showDetailModal = TaskHelpers.showDetailModal.bind(this);
    this.closeDetailModal = TaskHelpers.closeDetailModal.bind(this);
    this.swapModals = TaskHelpers.swapModals.bind(this);
    this.showDeleteModal = TaskHelpers.showDeleteModal.bind(this);
    this.closeDeleteModal = TaskHelpers.closeDeleteModal.bind(this);
    this.handleRecurrence = TaskHelpers.handleRecurrence.bind(this);
    this.handleAssignedToUser = TaskHelpers.handleAssignedToUser.bind(this);
    this.completeTask = TaskHelpers.completeTask.bind(this);
    this.uncompleteTask = TaskHelpers.uncompleteTask.bind(this);
    this.renderDeleteModal = TaskHelpers.renderDeleteModal.bind(this);
    this.renderDetailModal = TaskHelpers.renderDetailModal.bind(this);
    this.deleteTask = TaskHelpers.deleteTask.bind(this);
    this.renderModal = TaskHelpers.renderModal.bind(this);
    this.taskMultiSelect = TaskHelpers.taskMultiSelect.bind(this);
    this.showReassignModal = TaskHelpers.showReassignModal.bind(this);
    this.renderReassignModal = TaskHelpers.renderReassignModal.bind(this);
    this.closeReassignModal = TaskHelpers.showReassignModal.bind(this);
    this.setAgentsForModal = TaskHelpers.setAgentsForModal.bind(this);
    this.handleState = TaskHelpers.handleState.bind(this);
    this.handleRescheduleDate = TaskHelpers.handleRescheduleDate.bind(this);
    this.getTasks = this.props.getTasks.bind(this);
    this.weeklyOptions = TaskHelpers.weeklyOptions.bind(this);
    this.replaceURLWithHTMLLinks = TaskHelpers.replaceURLWithHTMLLinks.bind(this);
    this.completeAndEditAppointment = TaskHelpers.completeAndEditAppointment.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ ...this.state, ...nextProps });
  }

  toggleInstructions() {
    var task = { ...this.state.task };
    task["showInstructions"] = !task["showInstructions"];
    this.setState({ task });
  }

  onUpdateTaskTypeChecker = (e) => {
    if (this.state.task.type === "Appointment") {
      this.completeAndEditAppointment();
    } else this.handleTaskChange(e);
  };

  editMute = () => {
    return this.props.agent ? "" : "text-mute";
  };

  milestoneOptions = () => {
    const { accountMilestoneNames } = this.props;

    const personNames = accountMilestoneNames["Person"];
    const listingNames = accountMilestoneNames["Listing"];
    const projectNames = accountMilestoneNames["Project"];

    const allNamesArray = personNames.concat(listingNames).concat(projectNames);

    let allNamesObject = {};

    allNamesArray.forEach((name) => {
      allNamesObject[name] = name
        .split("_")
        .map((element) => capitalize(element))
        .join(" ");
    });

    return allNamesObject;
  };

  render() {
    const { task } = this.state;
    return (
      <div
        className={"tw-flex striped td task !tw-ml-0 " + this.props.dueness}
        data-object-id={task.id}
        data-contingent={task.check_contingency}
        data-dueness={task.dueness}
        data-incomplete-dueness={task.dueness}
        data-name={task.name}
      >
        <div className="tw-basis-5/12 tw-px-[8px] tw-overflow-hidden">
          <div className={this.props.nameColumnClass}>
            <div className="tw-flex tw-gap-[4px]">
              {/* check box select */}
              {!this.props.agent && (
                <CheckBox
                  divClass={task.dueness + " !tw-ml-0 fancy"}
                  labelClass={`${
                    task.state == "completed" ? "complete text-success checked" : "incomplete unchecked"
                  }`}
                  inputClass={"checkbox-input"}
                  inputChecked={task.state == "completed" && "checked"}
                  objectToCheck={task}
                  inputName={"complete"}
                />
              )}
              {this.props.agent && (
                <CheckBox
                  divClass={task.dueness + " !tw-ml-0 fancy"}
                  labelClass={`${
                    task.state === "completed" ? "complete text-success checked" : "incomplete unchecked"
                  }`}
                  inputClass="checkbox-input"
                  inputChecked={task.state === "completed"}
                  objectToCheck={task}
                  inputName="complete"
                  onUpdate={
                    task.type !== "Appointment"
                      ? this.onUpdateTaskTypeChecker
                      : () => this.props.editTask({ ...task, state: "completed" })
                  }
                />
              )}

              {/* Task name or link to Agent */}
              {!this.props.agent && (
                <div className="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
                  {task.assigned_plan_id && (
                    <span>
                      <i className={`fa fa-bolt m-r-5`} style={{ color: "#59c4c4" }} />
                    </span>
                  )}
                  {task.name}
                </div>
              )}
              {this.props.agent && (
                <div className="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
                  {task.assigned_plan_id && (
                    <span>
                      <i className={`fa fa-bolt m-r-5`} style={{ color: "#59c4c4" }} />
                    </span>
                  )}
                  <a onClick={() => this.props.showTaskDetails(task)} className="no-underline">
                    {task.name}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Task Date */}
        <div className="tw-basis-1/12 text-center overflow">
          {task.state == "completed" && (
            <div style={{ marginLeft: "-10px" }}>
              {task.completed_at && dayjs(task.completed_at).format("MM/DD/YYYY")}
            </div>
          )}
          {task.state != "completed" && (
            <div style={{ marginLeft: "-10px" }}>
              {task.calculated_due_on ? dayjs(task.calculated_due_on).format("MM/DD/YYYY") : "TBD"}
            </div>
          )}
        </div>

        <div className="tw-basis-1/12 text-center">
          {this.props.agent && (
            <span>
              {task.priority && <img src={`/images/task_priorities/${task.priority}.svg`} />}
              {!task.priority && <img src={`/images/task_priorities/empty.svg`} />}
            </span>
          )}
        </div>

        {/* Person image or default */}
        <div className="tw-basis-1/12 text-center who">
          {task.state == "completed" && <ProfileIcon dynamic={true} userId={task.completed_by_user_id} />}
          {task.state != "completed" && task.assigned_to_user_id && (
            <ProfileIcon dynamic={true} userId={task.assigned_to_user_id} />
          )}
          {task.assigned_to_user_id == null && task.completed_by_user_id == null && (
            <Tooltip placement="right" trigger={<img src="/images/users/team.svg" />} content="Anyone" />
          )}
        </div>

        {this.props.agent && <TaskSettings className="tw-basis-2/12" task={task} />}

        {/* Task Edit */}
        <div className="tw-basis-1/12">
          {this.props.agent && (
            <div>
              <span>
                <a onClick={() => this.props.editTask(task)} href={task.edit_path}>
                  <i className={"fa fa-pencil " + this.editMute()} />
                </a>
              </span>
              <span>
                <a href={"javascript:void(0)"} onClick={() => this.props.showDeleteModal(task)}>
                  <i className={"fa fa-times"} />
                </a>
              </span>
            </div>
          )}
        </div>

        {/* Multi-select */}
        <div className="tw-basis-1/12 text-center">
          {this.props.agent && (
            <CheckBox
              divClass={"task-multi-select display-inline-block"}
              labelClass={task.multi_select ? "checked" : "unchecked"}
              inputClass={"checkbox-input multi-select"}
              inputChecked={task.multi_select && "checked"}
              objectToCheck={task}
              inputName={"multi_select"}
              onUpdate={this.handleTaskChange}
            />
          )}
        </div>
      </div>
    );
  }
}

Task.propTypes = {
  task: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

Task.defaultProps = {
  task: {},
  user: { name: "No Name" },
  nameColumnClass: "task-column",
  taskCssStyle: "task",
};

export default connect(
  ({ layout }) => ({ accountMilestoneNames: layout.sidebar.accountMilestoneNames }),
  null,
)(Task);
